import { DURATION_OPTIONS_IN_MINUTES, DURATION_OPTIONS_IN_HOURS } from '../constants';

import durationPickerUrl from './durationPickerComponent.html';

class DurationPickerCtrl {
  constructor(sdk) {
    'ngInject';

    const { HOURS_OPTION_VALUE, MINUTES_OPTION_VALUE, DURATION_UNIT_OPTIONS } = sdk('constants');
    Object.assign(this, { DURATION_UNIT_OPTIONS, HOURS_OPTION_VALUE, MINUTES_OPTION_VALUE });
  }

  DURATION_OPTIONS_IN_MINUTES = DURATION_OPTIONS_IN_MINUTES;
  DURATION_OPTIONS_IN_HOURS = DURATION_OPTIONS_IN_HOURS;

  $onChanges({ unit }) {
    if (unit?.currentValue.value === this.HOURS_OPTION_VALUE) {
      this.durationInMinutes = this.duration * 60;
    }
  }

  get duration() {
    return this.unit.value === this.HOURS_OPTION_VALUE
      ? Math.ceil(this.durationInMinutes / 60)
      : this.durationInMinutes;
  }

  set duration(value) {
    this.durationInMinutes = this.unit.value === this.HOURS_OPTION_VALUE ? value * 60 : value;
  }
}

export default {
  templateUrl: durationPickerUrl,
  controller: DurationPickerCtrl,
  controllerAs: 'ctrl',
  bindings: {
    durationInMinutes: '=',
    unit: '<',
    isRequired: '<',
    onUnitChange: '&',
  },
};
